import type { FaireProductEntity } from "../../entity_types/product";

export const p_whajr4wyk6: FaireProductEntity = {
  token: "p_whajr4wyk6",
  type: "product",
  name: "Cat Design Decorative Bowl",
  brandToken: "b_bp2qh0z57y",
  brandName: "Nai Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/0b711bb227be22c1528cf57e6495954431817e5dad54285dbe357504c369f2a1.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.16,
  description:
    "For cat lovers cat design metal bowls to serve dry food,nuts or just as a decorative item. Design printed on both sides of the vibrantly coloured bowls ",
  tags: [],
  msrpDollars: 8.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:01.509Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
